<template>
  <span>
    <a-button
      :class="variant"
      v-bind="$attrs"
      @click="onClick"
    >
      <slot></slot>
    </a-button>
    <!-- <b-button
      v-bind="$attrs"
      @click="onClick"
      :disabled="isProcessing"
    >
      <span :class="{ 'invisible': isProcessing }" >
        <slot></slot>
      </span>
      <span v-if="isProcessing" class="processing-icon">
        <LmSpinnerBorder />
      </span>
    </b-button> -->
    <LmConfirmationModal :ref="`button-confirmation-modal-${_uid}`" />
  </span>
</template>

<script>
import LmConfirmationModal from '@/components/modals/LmConfirmationModal'
import LmSpinnerBorder from '@/components/LmSpinnerBorder'

export default {
  props: {
    isProcessing: {
      type: Boolean,
      default: false
    },
    confirmation: {
      type: Boolean,
      default: false
    },
    confirmationTitle: {
      type: String,
      default: 'Aviso'
    },
    confirmationMessage: {
      type: String,
      default: '¿Estas seguro?'
    },
    variant: {
      type: String,
      default: null
    }
  },

  components: {
    LmConfirmationModal,
    LmSpinnerBorder
  },

  computed: {
    btnVariant () {
      return {
        toolbarCtx: 'processes',
        areaValue: this.areaValue
      }
    }
  },
  methods: {
    async onClick (event) {
      try {
        if (this.confirmation) {
          this.$refs[`button-confirmation-modal-${this._uid}`].setTitleProps(this.confirmationTitle)
          this.$refs[`button-confirmation-modal-${this._uid}`].setMessageProps(this.confirmationMessage)
          await this.$refs[`button-confirmation-modal-${this._uid}`].lmShow()
        }
        this.$emit('click', event)
      } catch (error) {
        this.$emit('cancel', event)
      }
    }
  }
}
</script>

<style scoped>
button {
  position: relative;
}
button.ant-btn {
  line-height: 2;
}
button.ant-btn-primary.secondary {
  background-color: #6c757d;
  border-color: #6c757d;
}
button.ant-btn-primary.success {
  background-color: #28a745;
  border-color: #28a745;
}
button.ant-btn-primary.warning {
  background-color: #ffc107;
  border-color: #ffc107;
}
button.ant-btn-primary.info {
  background-color: #17a2b8;
  border-color: #17a2b8;
}
button.ant-btn.ant-btn-icon-only {
  display: flex;
  align-items: center;
  justify-content: center;
}
.processing-icon {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.processing-icon > span {
  vertical-align: sub;
}
.ant-btn-success {
  color: #fff !important;
  background-color: #28a745 !important;
  border-color: #28a745 !important;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
.ant-btn-success-disabled,
.ant-btn-success.disabled,
.ant-btn-success[disabled],
.ant-btn-success-disabled:hover,
.ant-btn-success.disabled:hover,
.ant-btn-success[disabled]:hover,
.ant-btn-success-disabled:focus,
.ant-btn-success.disabled:focus,
.ant-btn-success[disabled]:focus,
.ant-btn-success-disabled:active,
.ant-btn-success.disabled:active,
.ant-btn-success[disabled]:active,
.ant-btn-success-disabled.active,
.ant-btn-success.disabled.active,
.ant-btn-success[disabled].active {
  color: rgba(0, 0, 0, 0.25) !important;
  background-color: #f5f5f5 !important;
  border-color: #d9d9d9 !important;
  text-shadow: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.ant-btn-success:hover,
.ant-btn-success:focus {
  color: #fff !important;
  background-color: #34ce57 !important;
  border-color: #34ce57 !important;
}
.ant-btn-success:active,
.ant-btn-success.active {
  color: #fff !important;
  background-color: #1e7e34 !important;
  border-color: #1e7e34 !important;
}
.ant-btn-background-ghost.ant-btn-success {
  color: #28a745 !important;
  background: transparent !important;
  border-color: #28a745 !important;
  text-shadow: none !important;
}
.ant-btn-background-ghost.ant-btn-success:hover,
.ant-btn-background-ghost.ant-btn-success:focus {
  color: #34ce57 !important;
  background: transparent !important;
  border-color: #34ce57 !important;
}
.ant-btn-background-ghost.ant-btn-success:active,
.ant-btn-background-ghost.ant-btn-success.active {
  color: #28a745 !important;
  background: transparent !important;
  border-color: #1e7e34 !important;
}
.ant-btn-warning {
  color: #fff !important;
  background-color: #eca52b !important;
  border-color: #eca52b !important;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
.ant-btn-warning-disabled,
.ant-btn-warning.disabled,
.ant-btn-warning[disabled],
.ant-btn-warning-disabled:hover,
.ant-btn-warning.disabled:hover,
.ant-btn-warning[disabled]:hover,
.ant-btn-warning-disabled:focus,
.ant-btn-warning.disabled:focus,
.ant-btn-warning[disabled]:focus,
.ant-btn-warning-disabled:active,
.ant-btn-warning.disabled:active,
.ant-btn-warning[disabled]:active,
.ant-btn-warning-disabled.active,
.ant-btn-warning.disabled.active,
.ant-btn-warning[disabled].active {
  color: rgba(0, 0, 0, 0.25) !important;
  background-color: #f5f5f5 !important;
  border-color: #d9d9d9 !important;
  text-shadow: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.ant-btn-warning:hover,
.ant-btn-warning:focus {
  color: #fff !important;
  background-color: #f0b95a !important;
  border-color: #f0b95a !important;
}
.ant-btn-warning:active,
.ant-btn-warning.active {
  color: #fff !important;
  background-color: #d18b13 !important;
  border-color: #d18b13 !important;
}
.ant-btn-background-ghost.ant-btn-warning {
  color: #eca52b !important;
  background: transparent !important;
  border-color: #eca52b !important;
  text-shadow: none !important;
}
.ant-btn-background-ghost.ant-btn-warning:hover,
.ant-btn-background-ghost.ant-btn-warning:focus {
  color: #f0b95a !important;
  background: transparent !important;
  border-color: #f0b95a !important;
}
.ant-btn-background-ghost.ant-btn-warning:active,
.ant-btn-background-ghost.ant-btn-warning.active {
  color: #eca52b !important;
  background: transparent !important;
  border-color: #d18b13 !important;
}
.ant-btn-secondary {
  color: #fff !important;
  background-color: #6c757d !important;
  border-color: #6c757d !important;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
.ant-btn-info {
  color: #fff !important;
  background-color: #17a2b8 !important;
  border-color: #17a2b8 !important;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
</style>
